import { FC } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import Component from "./componentsWrappers/Component";
import TotalSales from "./componentsWrappers/TotalSales";
import EmptyTotalSection from "./empty/EmptyTotalSection";

interface TotalSalesMembersWrapperProps {
  sales?: any;
  percent?: any;
}
const TotalSalesSCGIcon = (width = "20", height = "22") => (
  <svg
    width="20"
    height="22"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.5 20.75C0.5 20.3358 0.835786 20 1.25 20H19.25C19.6642 20 20 20.3358 20 20.75C20 21.1642 19.6642 21.5 19.25 21.5H1.25C0.835786 21.5 0.5 21.1642 0.5 20.75Z"
      fill="#00086D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.5 8.13086C0.5 7.16665 1.28579 6.38086 2.25 6.38086H3.84998C4.81419 6.38086 5.59998 7.16665 5.59998 8.13086V16.7509C5.59998 17.7151 4.81419 18.5009 3.84998 18.5009H2.25C1.28579 18.5009 0.5 17.7151 0.5 16.7509V8.13086ZM2.25 7.88086C2.11421 7.88086 2 7.99507 2 8.13086V16.7509C2 16.8866 2.11421 17.0009 2.25 17.0009H3.84998C3.98576 17.0009 4.09998 16.8866 4.09998 16.7509V8.13086C4.09998 7.99507 3.98576 7.88086 3.84998 7.88086H2.25Z"
      fill="#00086D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.69922 4.93945C7.69922 3.97524 8.48501 3.18945 9.44922 3.18945H11.0492C12.0134 3.18945 12.7992 3.97524 12.7992 4.93945V16.7495C12.7992 17.7137 12.0134 18.4995 11.0492 18.4995H9.44922C8.48501 18.4995 7.69922 17.7137 7.69922 16.7495V4.93945ZM9.44922 4.68945C9.31343 4.68945 9.19922 4.80367 9.19922 4.93945V16.7495C9.19922 16.8852 9.31343 16.9995 9.44922 16.9995H11.0492C11.185 16.9995 11.2992 16.8852 11.2992 16.7495V4.93945C11.2992 4.80367 11.185 4.68945 11.0492 4.68945H9.44922Z"
      fill="#00086D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.8984 1.75C14.8984 0.785786 15.6842 0 16.6484 0H18.2484C19.2126 0 19.9984 0.785786 19.9984 1.75V16.75C19.9984 17.7142 19.2126 18.5 18.2484 18.5H16.6484C15.6842 18.5 14.8984 17.7142 14.8984 16.75V1.75ZM16.6484 1.5C16.5127 1.5 16.3984 1.61421 16.3984 1.75V16.75C16.3984 16.8858 16.5127 17 16.6484 17H18.2484C18.3842 17 18.4984 16.8858 18.4984 16.75V1.75C18.4984 1.61421 18.3842 1.5 18.2484 1.5H16.6484Z"
      fill="#00086D"
    />
  </svg>
);
const TotalSalesMembersWrapper: FC<TotalSalesMembersWrapperProps> = ({
  sales,
  percent,
}) => {
  const intl = useIntl();
  return (
    <div className="mx-0 max-lg:col-span-2 !w-full">
      {sales ? (
        <Component style="max-lg:!w-full">
          <TotalSales
            secondTitle={<FormattedMessage id="total_sales_title" />}
            title={<FormattedMessage id="SARshort" values={{ count: sales }} />}
            description={<FormattedMessage id="" />}
            count={sales}
            percent={percent}
            // icon={TotalSalesSCGIcon()}
          />
        </Component>
      ) : (
        <div className="">
          <EmptyTotalSection
            secondTitle={intl.formatMessage({
              id: "totalSales",
            })}
            title={
              <div className="flex items-center gap-2">
                <span className={`text-[#75757E]`}>0</span>
                {intl.formatMessage({
                  id: "SARshort",
                })}
              </div>
            }
            description=""
            // icon={TotalSalesSCGIcon()}
            paddingX="16px"
            paddingY="16px"
          />
        </div>
      )}
    </div>
  );
};

export default TotalSalesMembersWrapper;
